import { Box } from '@mui/material';
import { tokens } from '../../theme/tokens';
import { devanagariFamily } from '../../theme/typography';

/** Transparent crop of the supplied Rani Sati Dadiji artwork. */
export const dadijiSymbolSrc = '/images/rani-sati-dadiji.png';

const phraseSx = {
  flex: '0 0 auto',
};

export default function InvocationStrip() {
  return (
    <Box
      component="div"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: { xs: 28, sm: 32 },
        px: { xs: 1.25, md: 3 },
        backgroundColor: tokens.ivory,
        borderBottom: '1px solid',
        borderColor: tokens.line,
      }}
    >
      <Box
        component="p"
        sx={{
          m: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: '100%',
          gap: 'clamp(0.65rem, 3vw, 2.75rem)',
          color: tokens.navy,
          fontFamily: devanagariFamily,
          fontWeight: 500,
          fontSize: 'clamp(0.6875rem, 1.6vw, 0.8125rem)',
          lineHeight: 1.2,
          whiteSpace: 'nowrap',
        }}
      >
        <Box component="span" lang="sa" translate="no" sx={phraseSx}>
          श्री गणेशाय नमः
        </Box>
        <Box
          component="img"
          src={dadijiSymbolSrc}
          alt="Rani Sati Dadiji"
          width={140}
          height={168}
          decoding="async"
          sx={{
            flex: '0 0 auto',
            display: 'block',
            height: 'clamp(16px, 2.8vw, 22px)',
            width: 'auto',
          }}
        />
        <Box component="span" lang="sa" translate="no" sx={phraseSx}>
          श्री राणीसत्यै नमः
        </Box>
      </Box>
    </Box>
  );
}
